import { CountriesApi } from '@sparklayer-io/spark-dash-core/api/countries';
import { CubeApi } from '@sparklayer-io/spark-dash-core/api/cube';
import { SiteApi } from '@sparklayer-io/spark-dash-core/api/site';
import { StockLocationsApi } from '@sparklayer-io/spark-dash-core/api/stock-locations';
import type { ApiHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/api';
import type { Apis } from '../context/page-context';
import { AccountApi } from '../features/account/api';
import { APISettingsApi } from '../features/api-settings/api';
import { BillingApi } from '../features/billing/api';
import { CompaniesApi } from '../features/companies/api';
import { QuoteStatusesApi } from '../features/configurations/api';
import { CustomerGroupsApi } from '../features/customer-groups/api';
import { CustomersApi } from '../features/customers/api';
import { DiscountsApi } from '../features/discounts/api';
import { PriceListsApi } from '../features/price-lists/api';
import { PricingApi } from '../features/pricing/api';
import { ProductsApi } from '../features/products/api';
import { PurchasingApi } from '../features/purchases/api/purchasing';
import { ShippingMethodsApi } from '../features/shipping-methods/api';
import { StockApi } from '../features/stock/api';
import { StorefrontOptionsApi } from '../features/storefront-options/api';
import { SparkJsApi } from '../features/storefront-widgets/api';
import { SyncApi } from '../features/sync/api';
import { ThemesApi } from '../features/themes/api';

// Composition root for the shared pages. `@sparklayer-io/dashboard` spreads this and adds the
// apis of the dash-only features on top.
export function buildApis(apiHandler: ApiHandlerContract): Apis {
  return {
    billing: new BillingApi(apiHandler),
    companies: new CompaniesApi(apiHandler),
    countries: new CountriesApi(apiHandler),
    customers: new CustomersApi(apiHandler),
    customerGroups: new CustomerGroupsApi(apiHandler),
    discounts: new DiscountsApi(apiHandler),
    priceLists: new PriceListsApi(apiHandler),
    pricing: new PricingApi(apiHandler),
    products: new ProductsApi(apiHandler),
    quoteStatuses: new QuoteStatusesApi(apiHandler),
    shippingMethods: new ShippingMethodsApi(apiHandler),
    sparkJs: new SparkJsApi(apiHandler),
    storefrontOptions: new StorefrontOptionsApi(apiHandler),
    purchases: new PurchasingApi(apiHandler),
    account: new AccountApi(apiHandler),
    sync: new SyncApi(apiHandler),
    site: new SiteApi(apiHandler),
    stock: new StockApi(apiHandler),
    stockLocations: new StockLocationsApi(apiHandler),
    themes: new ThemesApi(apiHandler),
    cube: new CubeApi(apiHandler),
    APISettings: new APISettingsApi(apiHandler),
  };
}
